import BaseServiceCrud from './BaseServiceCrud';

export default class FileUploadService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'file';
    }

    uploadAttachemnt(formData, extension) {
        const headers = {
            Accept: 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Sec-Fetch-Site': 'same-origin',
            'Accept-Language': window.localStorage.i18nextLng,
            locale: window.localStorage.i18nextLng,
            Pragma: 'no-cahce',
        };
        return this.fetch(
            `${this.domain}/${this.path}${extension? `?ext=${extension}`: ''}`,
            {
                method: 'POST',
                body: formData,
            },
            headers
        ).catch((err) => {
            throw err;
        });
    }
}
